module.exports = __webpack_public_path__ + "img/tech-chip-icon.d57dbed1.svg";